import MoonIcon from '@/app/assets/svg/moon.svg?react';
import SunIcon from '@/app/assets/svg/sun.svg?react';
import { cn } from '@/app/shared/lib/cn';
import { useThemeStore } from '@/app/store/theme';

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useThemeStore();

  const isLight = theme === 'light';

  return (
    <button
      onClick={toggleTheme}
      className='flex h-10 w-full cursor-pointer items-center gap-1 overflow-hidden rounded-md bg-gray-800 p-0.5'
      aria-label='Toggle theme'
    >
      <div
        className={cn(
          'flex h-full flex-1 items-center justify-center rounded-sm transition-all duration-200 ease-in-out',
          !isLight ? 'bg-gray-700 text-gray-50' : 'bg-transparent text-gray-500',
        )}
      >
        <MoonIcon className='h-[18px] w-[18px] transition-transform duration-200' />
      </div>

      <div
        className={cn(
          'flex h-full flex-1 items-center justify-center rounded-sm transition-all duration-200 ease-in-out',
          isLight ? 'bg-[#EEF5FE] text-brand-400' : 'bg-transparent text-gray-500',
        )}
      >
        <SunIcon className='h-[18px] w-[18px] transition-transform duration-200' />
      </div>
    </button>
  );
};
